import React, { useEffect, useState } from "react"; 
import { maintenanceApi } from  "../../Restclient/datacollection";
import { Checkbox, Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrieval from './AssetTagsRetrieval';
import { useSelector } from "react-redux";
import Button from '@mui/material/Button';
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import LK_Delete from "../../images/LK_Delete";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import UserForm from "./UserForm"; 
import CustomButton from "../CommonComponents/CustomButton";
import UserFormResponse from "./UserFormResponse";
import { useApiHandler } from "../../hooks/useApiHandler";
import { ErrorTypes } from "../../Restclient/axiosConfig";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";

export default function PeriodicMaintenanceSchedule() {
    const [maintenancedetails, setmaintenancedetails] = useState({})
    const [selectedSubtype, setSelectedSubtype] = useState(null);
    const [assetdata,setAssetData] = useState(null);
    const [selectedTag, setSelectedTag] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const devicedetailsobject = useSelector((state) => state.mainpagedata.devicedetailsobject);
    const [selectedType, setSelectedType] = useState(null);
    const [devicesdata, setDevicesData] = useState([])
     const [pagesize, setPagesize] = useState(445)
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
    const [maintabs, setMainTabs] = useState(['Perform Maintenance', 'View Previous Maintenance Comments']);
    const [tabvalue, setTabValue] = useState('Perform Maintenance');
    const projectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    
    // Initialize useApiHandler hook
    const { loading, callApi, dialogState, closeDialog } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'No maintenance schedule found.',
        [ErrorTypes.SERVER_ERROR]: 'Failed to load maintenance data. Please try again.'
    });
    
    const handletabchange = (event, newValue) => {
        setTabValue(newValue);
    };

    function handleSubtypeSelection(subtypeId) {
        setSelectedSubtype(subtypeId);
    }

    function handleTypeSelection(typeId) {
        console.log("handleTypeSelection-typeId",typeId)
        setSelectedType(typeId);
    }

    var template = [
        {
            "description": "Alarm_R_Phase_Voltage",
            "responseType": "Multiple Choice",
            "options": [
                "a",
                "b",
                "c"
            ]
        },
        {
            "description": "qwerty",
            "responseType": "Yes/No",
            "options": []
        },
        {
            "description": "qwert",
            "responseType": "Descriptive",
            "options": []
        }
    ];

    // Fetch maintenance schedule using useApiHandler
    const fetchMaintenanceSchedule = async () => {
        await callApi(
            () => maintenanceApi.getSchedule(),
            {
                showDialog: false,  // Show dialog on success
                showDialogOnStatusCodes: [],  // Show dialog for auth/server errors
                hideDialogOnStatusCodes: [404],  // Silent for not found
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("resPeriodicMaintenanceSchedule", response);
                    if (response.data.success && response.data?.data?.maintenanceschedule?.DeviceIDObject) {
                        setmaintenancedetails(response.data.data.maintenanceschedule?.DeviceIDObject);
                    } else {
                        setmaintenancedetails({});
                    }
                },
                onError: (error) => {
                    console.error("Error fetching maintenance schedule:", error);
                    setmaintenancedetails({});
                }
            }
        );
    };

    // Fetch devices using useApiHandler
    const fetchDevices = async () => {
        await callApi(
            () => maintenanceApi.getDevices(),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                showDialogOnCatch: false,
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("fetchDevices", response);
                    if(response.data.success && response.data.data && response.data?.data.devices){
                        setDevicesData(response.data?.data.devices);
                    }else{
                        setDevicesData([]);
                    }
                },
                onError: (error) => {
                    console.error("Error fetching devices:", error);
                    setDevicesData([]);
                },
                onCatchError: (error, errorInfo) => {
                    console.error("Unexpected error fetching devices:", error, errorInfo);
                    setDevicesData([]);
                }
            }
        );
    };

     useEffect(() => {
                 //console.log("overviewstate ", overviewstate)
                 if (overviewstate) {
                     setPagesize(445)
                 } else {
                     setPagesize(410)
                 }
         }, [overviewstate])

    useEffect(() => {
        console.log("userdetails in PeriodicMaintenanceSchedule.js PeriodicMaintenanceSchedule", userdetails)
        fetchDevices();
        fetchMaintenanceSchedule();
    }, [projectname])

    return(
        <Box className="parentDiv" style={{width: "100%",boxSizing: 'border-box'}}>
            <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px',marginBottom:"20px"}} >
                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"8px",textAlign:"left",marginTop:"10px"}}>Select Device to Perform Maintenance & to View Previous Maintenance Records</Typography>
                <Box sx={{flexGrow:1,}}></Box>
            </Box>
            <div style={{display: "flex", flexDirection:"row", width: "100%", boxSizing:"border-box", gap:"28px",}}>
                    <div style={{display:'flex', flexDirection:'column', width:"20%"}}>
                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"8px",textAlign:"left",marginTop:"0px"}}>Selected Device : <span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span>{devicedetailsobject[selectedType]?.Name}</Typography>
                        <div style={{ width:'100%',marginTop:"3px", border: "1px solid #008CD7",marginLeft:"8px",boxSizing:"border-box", overflowY:'scroll',height:`calc(100vh - ${pagesize}px)`}}>
                            <SimpleTreeView
                                sx={{
                                color: "var(--SecondaryText)",
                                "& .MuiTreeItem-label .MuiTreeItem-content": {
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    color: "red",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textAlign: "left", // Align labels to the left
                                },
                                }}
                                defaultCollapseIcon="-"
                                defaultExpandIcon="+"
                            >
                                {devicesdata.map((device) => (
                                    <TreeItem key={device.id} itemId={device.DeviceID} sx={{ textAlign:'left' }} label={
                                        <FormControlLabel
                                        control={
                                            <input
                                                type="radio"
                                                checked={selectedType === device.DeviceID} // Controlled by the state
                                                onChange={() => handleTypeSelection(device.DeviceID)}
                                                />
                                        }
                                        label={device.Name}
                                        sx={{textAlign: "left",}}
                                    />
                                    } />
                                ))}
                            </SimpleTreeView>
                        </div>
                    </div>
                    <div style={{width:"80%", display: "flex", flexDirection:"row", alignItems:"baseline",boxSizing:"border-box", marginRight:"10px"}}>
                        <Box sx={{/*width:`calc(100vw - ${1702}px)`*/ width: '100%',marginTop:"0px", height: "330px", backgroundColor: 'var(--SecondaryBackground)', borderRadius: '0px 0px 0px 0px', marginRight: '0px' }}>
                            <Box sx={{ backgroundColor: 'var(--SecondaryBackground)', }}>
                                <Tabs
                                    value={tabvalue}
                                    onChange={handletabchange}
                                    aria-label="basic tabs example"
                                    sx={{
                                        width: 'auto',
                                        '& .MuiTabs-indicator': { display: 'none' },
                                        '& .Mui-selected': {
                                            backgroundColor: 'var(--PrimaryBackground)',
                                            borderRadius: '0px 0px 0px 0px',
                                            color: 'var(--LK_BrandBlue_1) !important',
                                            fontWeight: '700 !important',
                                            borderTop: "1px solid var(--HighlightedText_Stroke)",
                                            borderLeft: "1px solid var(--HighlightedText_Stroke)",
                                            borderRight: "1px solid var(--HighlightedText_Stroke)",
                                            borderBottom: "1px solid var(--SecondaryBackground)",
                                        },
                                        '& .MuiTab-root': {
                                            padding: '8px 8px 6px 8px !important',
                                            margin: '0px !important',
                                            minWidth: '63px',
                                        },
                                        minHeight: '30px',
                                        marginBottom: '-3px'
                                    }}>
                                    {maintabs.map((tab) => {
                                        return (
                                            <Tab
                                            sx={{
                                                minHeight: "30px",
                                                height: "30px",
                                            }}
                                            style={{
                                                color: "var(--GreyVariation_2)",
                                                fontFamily: "Roboto",
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                lineHeight: "16.75px",
                                                textTransform: "capitalize",
                                            }}
                                            value={tab}
                                            label={tab}
                                            >
                                            {tab}
                                            </Tab>
                                        );
                                    })}
                                </Tabs>
                            </Box>
                            <Box sx={{ backgroundColor: 'var(--PrimaryBackground)', width: '100%', border: "1px solid var(--HighlightedText_Stroke)", height:`calc(100vh - ${pagesize}px)`, boxSizing:'border-box' }} style={{ overflow: "auto", }}>
                                    {tabvalue == 'Perform Maintenance' && (
                                        <div style={{marginTop:"26px", width:"97.8%",marginLeft:"14px",marginRight:"14px", boxSizing:'border-box'}}>
                                            {console.log("Periodic Mainteance Schedule selectedType",selectedType,"maintenancedetails",maintenancedetails)}
                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Note: Descriptive responses have upper limit of 40 characters</Typography>
                                            {(selectedType!=null) && (selectedType!=undefined) && (maintenancedetails.hasOwnProperty(selectedType)) && <UserForm id={maintenancedetails[selectedType].id} maintenanceinfo={selectedType} template={maintenancedetails[selectedType].checkListMaintenance} lastmaintenanceperformeddate={maintenancedetails[selectedType].lastmaintenanceperformeddate} maintenanceintervaldays={maintenancedetails[selectedType].maintenanceintervaldays} nextmaintenancedate={maintenancedetails[selectedType].nextmaintenancedate}/>}
                                        </div>
                                    )}
                                    {tabvalue == 'View Previous Maintenance Comments' && (
                                        <div style={{marginTop:"26px", width:"97.8%",marginLeft:"14px",marginRight:"14px", boxSizing:'border-box'}}>
                                            {maintenancedetails[selectedType] ==undefined && maintenancedetails[selectedType] ==null &&  <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>No Details Found for Selected Device</Typography>}
                                            {maintenancedetails[selectedType] !=undefined && maintenancedetails[selectedType] !=null &&  
                                                <>
                                                    {console.log("maintenancedetails[selectedType].responses",maintenancedetails[selectedType].checkListMaintenance)}
                                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Previous 5 Maintenance Responses</Typography>
                                                    <UserFormResponse id={maintenancedetails[selectedType].id} maintenanceinfo={selectedType} template={maintenancedetails[selectedType].checkListMaintenance} lastmaintenanceperformeddate={maintenancedetails[selectedType].lastmaintenanceperformeddate} maintenanceintervaldays={maintenancedetails[selectedType].maintenanceintervaldays} nextmaintenancedate={maintenancedetails[selectedType].nextmaintenancedate} responsesobtained={maintenancedetails[selectedType].responses}/>
                                                </>
                                            }
                                        </div>
                                    )}
                                    
                            </Box>
                        </Box>
                    </div>  
            </div>
            
            {/* CustomDialogBox for error/success messages */}
            <CustomDialogBox 
                open={dialogState.open}
                title={dialogState.title}
                contentText={dialogState.message}
                onConfirm={dialogState.onConfirm || closeDialog}
                onClose={closeDialog}
                confirmText={dialogState.confirmText}
                cancelText={dialogState.cancelText}
                showCancel={dialogState.showCancel}
                onCancel={dialogState.onCancel}
                dialogType={dialogState.type}
            />
       </Box>
    )
}

{/*
    <div style={{ display: "block", width: "100%" }}>
                    
                        <SimpleTreeView
                            sx={{
                            color: "var(--SecondaryText)",
                            "& .MuiTreeItem-label .MuiTreeItem-content": {
                                fontSize: "16px",
                                fontWeight: 400,
                                color: "red",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                            },
                            }}
                            defaultCollapseIcon="-"
                            defaultExpandIcon="+"
                        >
                            {maintenancetreedata.map((type) => (
                            <TreeItem key={type.id} itemId={type.TypeID} label={type.TypeName}>
                                {type.subtypes.map((subtype) => (
                                <TreeItem
                                    key={subtype.id}
                                    itemId={subtype.SubTypeID}
                                    label={
                                    <FormControlLabel
                                        control={
                                        <Checkbox
                                            checked={selectedSubtype === subtype.SubTypeID}
                                            onChange={() => handleSubtypeSelection(subtype.SubTypeID)}
                                        />
                                        }
                                        label={subtype.SubTypeName}
                                    />
                                    }
                                >
                                    {subtype.devices.map((device) => (
                                    <TreeItem key={device.id} itemId={device.DeviceID} label={device.Name} />
                                    ))}
                                </TreeItem>
                                ))}
                            </TreeItem>
                            ))}
                        </SimpleTreeView>
        </div>
        */}

{/*<div style={{ display: "flex", flexDirection:"row", flexWrap:'wrap', width: "100%",gap:"10px", boxSizing:"border-box",padding:"10px" }}> 
    {console.log("reached here PeriodicMaintenanceSchedule",maintenancedetails)}
    Object.keys(maintenancedetails).map((maintenanceinfo, index) => (
        //maintenanceinfo here is DeviceID which is key as per backend logic
        <UserForm id={maintenancedetails[maintenanceinfo].id} maintenanceinfo={maintenanceinfo} template={maintenancedetails[maintenanceinfo].checkListMaintenance} lastmaintenanceperformeddate={maintenancedetails[maintenanceinfo].lastmaintenanceperformeddate} maintenanceintervaldays={maintenancedetails[maintenanceinfo].maintenanceintervaldays} nextmaintenancedate={maintenancedetails[maintenanceinfo].nextmaintenancedate}/>
    ))
    
</div> */}